import { ComponentDefinition } from '@contentful/experiences-sdk-react';

export const tabSectionDefinition: ComponentDefinition = {
  id: 'tabSection',
  name: 'Tab Section',
  category: 'Custom',
  thumbnailUrl: 'https://unpkg.com/lucide-static/icons/panel-top.svg',
  children: true,
  variables: {
    sectionId: {
      type: 'Text',
      displayName: 'Section ID (anchor)',
      validations: { bindingSourceType: ['manual', 'experience', 'entry', 'asset'] },
    },
    ctaLabel: {
      type: 'Text',
      displayName: 'CTA Label',
      validations: { bindingSourceType: ['manual', 'experience', 'entry', 'asset'] },
    },
    ctaUrl: {
      type: 'Text',
      displayName: 'CTA URL',
      validations: { bindingSourceType: ['manual', 'experience', 'entry', 'asset'] },
    },
  },
} as const;
